import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import StarekContext from "../../context/StarekContext";

const PLANS = [
    {
        key: "starter",
        label: "Starter",
        price: "Contact Sales",
        highlight: false,
        features: [
            "Up to 2 Plants",
            "Up to 10 Devices",
            "200 Reports / month",
            "Role-based access control",
            "Email notifications",
        ],
    },
    {
        key: "pro",
        label: "Pro",
        price: "Contact Sales",
        highlight: true,
        badge: "Most Popular",
        features: [
            "Up to 10 Plants",
            "Up to 1,000 Devices (packs of 10)",
            "5,000 Reports / month",
            "Everything in Starter",
            "Webhook integrations",
            "Priority support",
        ],
    },
    {
        key: "custom",
        label: "Custom",
        price: "Talk to us",
        highlight: false,
        features: [
            "Unlimited Plants",
            "Unlimited Devices",
            "Unlimited Reports",
            "Everything in Pro",
            "Dedicated support",
            "Custom SLA",
        ],
    },
];

function StarekPlansModal({ show, handleClose }) {
    const { subscription } = useContext(StarekContext);
    const currentPlan = subscription?.plan ?? "starter";

    return (
        <Modal show={show} onHide={handleClose} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <i className="fa fa-crown me-2 text-warning"></i>
                    Subscription Plans
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-4">
                <p className="text-muted mb-4 text-center">
                    Choose the plan that fits your operation. All plans include
                    core device monitoring, scheduling, and reporting features.
                </p>
                <div className="row g-3">
                    {PLANS.map((plan) => {
                        const isActive = currentPlan === plan.key;
                        return (
                            <div key={plan.key} className="col-12 col-md-4 d-flex align-items-stretch">
                                <div
                                    className={`card w-100 position-relative ${
                                        plan.highlight
                                            ? "border-primary border-2 shadow"
                                            : "border"
                                    }`}
                                    style={{ borderRadius: "0.75rem", overflow: "hidden" }}
                                >
                                    {/* Popular badge */}
                                    {plan.badge && (
                                        <div
                                            className="bg-primary text-white text-center py-1"
                                            style={{ fontSize: "0.75rem", fontWeight: 600, letterSpacing: "0.05em" }}
                                        >
                                            {plan.badge}
                                        </div>
                                    )}

                                    <div className="card-body d-flex flex-column p-4">
                                        {/* Plan name & price */}
                                        <div className="mb-3">
                                            <h5 className="fw-bold mb-1">{plan.label}</h5>
                                            {/* <div className="text-muted" style={{ fontSize: "0.9rem" }}>
                                                {plan.price}
                                            </div> */}
                                        </div>

                                        {/* Features */}
                                        <ul className="list-unstyled mb-4 flex-grow-1">
                                            {plan.features.map((f) => (
                                                <li key={f} className="mb-2 d-flex align-items-start gap-2">
                                                    <i className="far fa-check-circle text-success mt-1" style={{ flexShrink: 0 }}></i>
                                                    <span style={{ fontSize: "0.9rem" }}>{f}</span>
                                                </li>
                                            ))}
                                        </ul>

                                        {/* CTA */}
                                        <div className="mt-auto">
                                            {isActive ? (
                                                <div className="text-center">
                                                    <span className="badge bg-success px-3 py-2" style={{ fontSize: "0.85rem" }}>
                                                        <i className="fa fa-check me-1"></i>
                                                        Current Plan
                                                    </span>
                                                </div>
                                            ) : plan.key === "custom" ? (
                                                <a
                                                    href="mailto:sales@starek.com?subject=Custom Plan Enquiry"
                                                    className="btn btn-outline-primary w-100"
                                                >
                                                    Contact Sales
                                                </a>
                                            ) : (
                                                <a
                                                    href="mailto:sales@starek.com?subject=Upgrade to Starek Pro"
                                                    className="btn btn-primary w-100"
                                                >
                                                    Upgrade to {plan.label}
                                                </a>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* Current usage summary */}
                {subscription && (
                    <div className="mt-4 p-3 bg-light rounded border">
                        <div className="d-flex flex-wrap gap-4 align-items-center">
                            <strong className="text-muted" style={{ fontSize: "0.85rem" }}>
                                Current Usage
                            </strong>
                            <span style={{ fontSize: "0.85rem" }}>
                                <i className="fa fa-leaf text-success me-1"></i>
                                <strong>{subscription.usage?.plants ?? "—"}</strong>
                                {" / "}
                                {subscription.limits?.plants === -1 ? "∞" : subscription.limits?.plants} plants
                            </span>
                            <span style={{ fontSize: "0.85rem" }}>
                                <i className="fa fa-microchip text-primary me-1"></i>
                                <strong>{subscription.usage?.devices ?? "—"}</strong>
                                {" / "}
                                {subscription.limits?.devices === -1 ? "∞" : subscription.limits?.devices} devices
                            </span>
                            <span style={{ fontSize: "0.85rem" }}>
                                <i className="fa fa-file-alt text-secondary me-1"></i>
                                {subscription.limits?.reportsPerMonth === -1
                                    ? "Unlimited reports / mo"
                                    : `${subscription.limits?.reportsPerMonth?.toLocaleString()} reports / mo`}
                            </span>
                        </div>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
}

export default StarekPlansModal;
